import { CART_ICON_WIDTH, CURRENT_PRODUCT_PLACEHOLDER, SELECTED_MODEL_PLACEHOLDER, } from './constants';
const DEFAULT_WIDTH_ONE_LETTER = 13;
const COMMON_BTN_PADDING = 48;
const COEFFICIENT_SPACE = 6;
export function getButtonPanelParam(props) {
    const { isAddToCardVisible, buttonAddToCartLabel, requestTestRideButtonLabel, blockWrapperWidth, isTestRideAllow, firstButtonLabelSize, secondButtonLabelSize, } = props;
    // Special condition for 'Test Ride Button'
    const count = isAddToCardVisible && isTestRideAllow ? 2 : 1;
    const gapValue = count === 2 ? 12 : 0;
    const firstBtnLength = (firstButtonLabelSize
        ? firstButtonLabelSize + CART_ICON_WIDTH
        : buttonAddToCartLabel.length * DEFAULT_WIDTH_ONE_LETTER) +
        COEFFICIENT_SPACE +
        COMMON_BTN_PADDING;
    const secondBtnLength = isTestRideAllow
        ? (secondButtonLabelSize || requestTestRideButtonLabel.length * DEFAULT_WIDTH_ONE_LETTER) +
            COMMON_BTN_PADDING +
            gapValue
        : 0;
    const amountSize = firstBtnLength + secondBtnLength;
    const isButtonInline = blockWrapperWidth ? blockWrapperWidth > amountSize : false;
    return {
        gapValue,
        count,
        isButtonInline,
    };
}
export const getModalDescription = (originalString, selectedModel, currentProduct) => originalString &&
    originalString
        .replace(SELECTED_MODEL_PLACEHOLDER, selectedModel)
        .replace(CURRENT_PRODUCT_PLACEHOLDER, currentProduct);
